import { CERNER_PID_TYPE, getCernerFpa } from '../../utils/cerner';
import {
  createEhrPatientDemographicCallback,
  createEhrPatientProxiesCallback
} from '../utils';
import { getDefaultConfig } from './getDefaultConfig';
import { getPersistedTokenValue } from '../../tracking/persisted-tokens';

/**
 * Function that returns the Cerner-specific config for Direct Book.
 * @param {Object} props - The config properties
 * @param {function} props.log - The log/track function
 * @param {string} props.customerCode - represents a customer
 * @param {Object} props.location - the react-router location object
 * @param {Object} props.tokens - tokens from pmc redux store
 * @param {Object} props.searchSDK
 * @returns the Cerner-specific config
 */
export const getCernerConfig = ({
  log,
  featureFlags,
  customerCode,
  location,
  tokens,
  config,
  searchSDK
}) => {
  const baseConfig = getDefaultConfig({
    customerCode,
    location,
    tokens,
    config,
    searchSDK
  });

  const bcsToken = getPersistedTokenValue('bcsToken');

  return {
    ...baseConfig,
    showApptSummary: false,
    ehr: {
      pid: getCernerFpa(bcsToken),
      pid_type: CERNER_PID_TYPE,
      ...featureFlags
    },
    services: {
      ...baseConfig.services,
      getEhrPatientDemographics: createEhrPatientDemographicCallback(
        log,
        customerCode
      ),
      getEhrPatientProxyDemographics: createEhrPatientProxiesCallback(
        log,
        customerCode
      )
    }
  };
};
